import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Box, 
  Container,
  Typography
} from '@mui/material';

// import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
// import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
// import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';

import "../../../../global.scss";
import "./styles.scss";

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <Container 
      maxWidth="sm">
      <Box
        className="flexCenterCenterColumn"
        gap={"20px"}
        height={"calc(100vh - 150px)"}>
        <Box
          className="core__block block flexCenterCenterColumn"
          gap={"15px"}
          onClick={() => navigate("quickbooks-desktop/connections")}>
          <Typography
            variant='h6'>
            Quickbooks Desktop
          </Typography>
        </Box>
        <Box
          className="block core__block flexCenterCenterColumn"
          gap={"15px"}
          onClick={() => navigate("quickbooks-online")}>
          <Typography
            variant='h6'>
            Quickbooks Online
          </Typography>
        </Box>

        <Box
          className="block core__block flexCenterCenterColumn"
          gap={"15px"}
          onClick={() => navigate("xero")}>

          <Typography
            variant='h6'>
            Xero
          </Typography>
        </Box>
      </Box>
    </Container>
  )
}

export default HomePage;